import { render } from "./CEditPurchaser.vue?vue&type=template&id=c0c1573a"
import script from "./CEditPurchaser.vue?vue&type=script&lang=js"
export * from "./CEditPurchaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__